import { render, staticRenderFns } from "./CardStatusTransition.vue?vue&type=template&id=54b4107b"
import script from "./CardStatusTransition.vue?vue&type=script&lang=js"
export * from "./CardStatusTransition.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54b4107b')) {
      api.createRecord('54b4107b', component.options)
    } else {
      api.reload('54b4107b', component.options)
    }
    module.hot.accept("./CardStatusTransition.vue?vue&type=template&id=54b4107b", function () {
      api.rerender('54b4107b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/CardStatusTransition.vue"
export default component.exports